import { copyValue, secondsToTime } from "../../../../shared/utility";
import PropTypes from 'prop-types';
import NameInitialsAvatar from "./NameInitialsAvatar";

const TranscriptAISummaryTab = ({ filteredTranscription, localisedValues, startTimeStampListRef }) => {

	const copyLink = (text) => {
		copyValue(text, localisedValues?.copied_to_clipboard_ai_summary_text);
	};

	return (
		<div className="session-transcript">
			<div className="session-transcript-left">
				{filteredTranscription?.map((transcriptionData, index) => {
					if (startTimeStampListRef.current === null) {
						startTimeStampListRef.current = transcriptionData.SystemTimeStamp; // set first message as start
					}
					const elapsedSeconds = transcriptionData.SystemTimeStamp - startTimeStampListRef.current;
					return (
						<div className="session-transcript-box" key={index} >
							<div className="transcript-icon">
								<div className="image">
									<NameInitialsAvatar Name={transcriptionData.Name} />
								</div>
							</div>
							<div className="transcript-text">
								<div className="transcript-text-head">
									<div className="participant-name">{transcriptionData?.Name || "Participant"}</div>
									<div className="transcript-time">{secondsToTime(elapsedSeconds || 0)}</div>
									<div className="transcript-copy">
										<button
											type="button"
											className="copy-btn"
											onClick={() => copyLink(transcriptionData?.Text)}
											aria-label={localisedValues?.copy_transcript_text}
										>
											<span className="for-icon icon-copy" aria-hidden="true"></span>
										</button>
									</div>
								</div>
								<div className="transcript-msg">
									<p>{transcriptionData?.Text}</p>
								</div>
							</div>
						</div>
					)
				})}
			</div>
		</div>
	);
};

TranscriptAISummaryTab.propTypes = {
	filteredTranscription: PropTypes.any,
	localisedValues: PropTypes.object,
	startTimeStampListRef: PropTypes.any,
};

export default TranscriptAISummaryTab;
